import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'src/components/filters';
import { Translate } from 'src/components/translate';
import { BodySmallText } from '@prisjakt/ui/text/variants';

const mapCategories = (categories, counters) =>
  categories
    .filter(item => counters[item.id])
    .map(item => {
      const category = {
        id: item.id,
        name: item.name,
        products: counters[item.id] || 0,
      };

      if (item.children) {
        category.children = mapCategories(item.children, counters);
      }

      return category;
    });

const findCategory = (items, selected) => {
  if (!selected.parents || selected.parents.length === 0) {
    return items.find(item => item.id === selected.value);
  }

  return selected.parents
    .map(p => p.id)
    .reverse()
    .concat(selected.value)
    .reduce((itemTree, curr) => {
      const match = itemTree.find(node => node.id === curr);

      if (match.id === selected.value) {
        return match;
      }

      return match.children;
    }, items);
};

const Categories = props => {
  const aggregation = props.aggregations || [];

  const counters = aggregation.reduce(
    (all, curr) =>
      Object.assign(all, {
        [curr.key]: curr.doc_count,
      }),
    {}
  );

  const categoryTree = props.categoryTree || [];
  const items = mapCategories(categoryTree, counters);

  return (
    <span>
      {items.length !== 0 && (
        <List
          id="category"
          values={items}
          selected={props.selected}
          onChange={selected => {
            props.onChange(selected, findCategory(items, selected));
          }}
          expanded={props.expanded}
          onExpand={props.onExpand}
          autoSelectChildren={false}
        />
      )}

      {items.length === 0 && (
        <BodySmallText container="p">
          <Translate domain="campaigns">category.no-items</Translate>
        </BodySmallText>
      )}
    </span>
  );
};

const { func, object, arrayOf, string, number, array, shape } = PropTypes;

Categories.propTypes = {
  onChange: func.isRequired,
  currentState: object,
  aggregations: arrayOf(
    shape({
      key: string,
      doc_count: number,
    })
  ),
  selected: arrayOf(string).isRequired,
  expanded: arrayOf(string).isRequired,
  onExpand: func.isRequired,
  categoryTree: array,
  data: object,
  campaignId: number.isRequired,
};

Categories.defaultProps = {
  aggregations: [],
  categoryTree: undefined,
  data: undefined,
  currentState: { selected: [] },
};

export default Categories;
